/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconInlineTopLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 20 20">
    <><path opacity="0.5" d="M 2,3 H 18 V 4.5 H 2 Z M 13.5,6 H 18 V 7.5 H 13.5 V 6.75 Z M 2,15 h 16 v 1.5 H 2 Z" />
<path d="m 12.003,7 v 5.5 a 1,1 0 0 1 -1,1 H 2.996 a 1,1 0 0 1 -1,-1 V 7 a 1,1 0 0 1 1,-1 h 8.007 a 1,1 0 0 1 1,1 z M 10.497,7.5 H 3.5 V 12 h 6.997 z" /></>
  </Icon>
);
};

IconInlineTopLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyBjbGFzcz0iY2sgY2staWNvbiBjay1yZXNldF9hbGwtZXhjbHVkZWQgY2staWNvbl9pbmhlcml0LWNvbG9yIGNrLWJ1dHRvbl9faWNvbiIgdmlld0JveD0iMCAwIDIwIDIwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIG9wYWNpdHk9IjAuNSIgZD0iTSAyLDMgSCAxOCBWIDQuNSBIIDIgWiBNIDEzLjUsNiBIIDE4IFYgNy41IEggMTMuNSBWIDYuNzUgWiBNIDIsMTUgaCAxNiB2IDEuNSBIIDIgWiIvPgogIDxwYXRoIGQ9Im0gMTIuMDAzLDcgdiA1LjUgYSAxLDEgMCAwIDEgLTEsMSBIIDIuOTk2IGEgMSwxIDAgMCAxIC0xLC0xIFYgNyBhIDEsMSAwIDAgMSAxLC0xIGggOC4wMDcgYSAxLDEgMCAwIDEgMSwxIHogTSAxMC40OTcsNy41IEggMy41IFYgMTIgaCA2Ljk5NyB6Ii8+Cjwvc3ZnPg==";
IconInlineTopLineComponent.Content = `<svg class="ck ck-icon ck-reset_all-excluded ck-icon_inherit-color ck-button__icon" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path opacity="0.5" d="M 2,3 H 18 V 4.5 H 2 Z M 13.5,6 H 18 V 7.5 H 13.5 V 6.75 Z M 2,15 h 16 v 1.5 H 2 Z"/>
  <path d="m 12.003,7 v 5.5 a 1,1 0 0 1 -1,1 H 2.996 a 1,1 0 0 1 -1,-1 V 7 a 1,1 0 0 1 1,-1 h 8.007 a 1,1 0 0 1 1,1 z M 10.497,7.5 H 3.5 V 12 h 6.997 z"/>
</svg>`;

const IconInlineTopLine = styled(IconInlineTopLineComponent)``;

export default IconInlineTopLine;
